import React from "react";
import { useRecoilState } from "recoil";
import { nightParkingState } from "../../state/QuoteState";
import SummaryItem from "../../components/SummaryItem";
import CustomDivider from "../../components/CustomDivider";
import { Parking } from "../../enums/Parking";

const NightParkingSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [
    {
      address1,
      address2,
      address3,
      parkingLocation,
      parkingMethod,
      postalCode,
      suburb,
    },
  ] = useRecoilState(nightParkingState);

  return (
    <>
      <SummaryItem items={[parkingMethod]} onEdit={onEdit}>
        Parking Method
      </SummaryItem>
      <CustomDivider />
      <SummaryItem
        items={[
          parkingLocation === Parking.SAME ? "Same as residential address" : "",
          address1,
          address2,
          address3,
          postalCode,
          suburb,
        ]}
        onEdit={onEdit}
      >
        Address
      </SummaryItem>
    </>
  );
};

export default NightParkingSummary;
